import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import ErrorDetails from "components/ErrorDetails";

type ErrorPopupProps = {
  isOpen: boolean;
  icon?: React.ReactNode;
  title: string;
  description?: string;
  onClose?: () => void;
};

const ErrorPopup: React.FC<ErrorPopupProps> = ({
  isOpen,
  icon,
  title,
  description,
  onClose,
  children,
}) => (
  <Modal
    isOpen={isOpen}
    {...(onClose
      ? {
          onClose,
        }
      : {
          closeOnOverlayClick: false,
          closeOnEsc: false,
          onClose: () => {},
        })}
    autoFocus={false}
    size="sm"
  >
    <ModalOverlay />

    <ModalContent px={4} py={4}>
      {onClose && <ModalCloseButton />}

      <ModalBody
        display="flex"
        flexDir="column"
        alignItems="center"
        textAlign="center"
      >
        <ErrorDetails
          icon={icon}
          title={title}
          description={description}
          color="bright.400"
        >
          {children}
        </ErrorDetails>
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default ErrorPopup;
